import React from "react";
import useInView from "../../hooks/useInView";

const DIRECTIONS = {
  up: "translate-y-8",
  down: "-translate-y-8",
  left: "translate-x-8",
  right: "-translate-x-8",
  none: "",
};

const Reveal = ({
  as: Tag = "div",
  direction = "up",
  delay = 0,
  duration = 700,
  className = "",
  children,
}) => {
  const [ref, inView] = useInView();

  return (
    <Tag
      ref={ref}
      className={`transition-all ease-out will-change-transform ${
        inView
          ? "translate-x-0 translate-y-0 opacity-100"
          : `opacity-0 ${DIRECTIONS[direction]}`
      } ${className}`}
      style={{ transitionDuration: `${duration}ms`, transitionDelay: `${delay}ms` }}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
